var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tip"},[_c('div',[_vm._v("移动端正在开发中...")]),_c('div',[_vm._v("如有需要请先移步PC端,")]),_c('div',[_vm._v("给您带来的不便，尽请谅解。")])])])}]

export { render, staticRenderFns }